import React, { useEffect } from "react";
import { IonContent, IonToolbar, IonIcon, IonButton, IonHeader, IonButtons } from '@ionic/react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import './UnsupportedRegion.css';
import { closeOutline, globeOutline, shieldOutline } from "ionicons/icons";

import { App, BackButtonListenerEvent } from '@capacitor/app';

type MyModalProps = {

    closeAction?: Function;

}

const UnsupportedRegionModal: React.FC<MyModalProps> = (props) => {

    const { t } = useTranslation();

    useEffect(() => {
        if (!props.closeAction) return;

        let backButtonListener:any;
    
        const setupBackButtonListener = async () => {
            backButtonListener = await App.addListener('backButton', (ev: BackButtonListenerEvent) => {
                props.closeAction!();
            });
        };
    
        setupBackButtonListener();
    
        // Cleanup function
        return () => {
            backButtonListener?.remove();
        };
    }, [props.closeAction]);


    return (
        <>
            <IonHeader className="ion-no-border unsupported-region-header">
                <IonToolbar style={{ '--background': '#04394F', '--border-width': '0', '--border-style': 'none' } as any}>
                    {props.closeAction && (
                    <IonButtons slot="start">
                        <IonButton onClick={() => { props.closeAction!() }}>
                            <IonIcon slot="icon-only" icon={closeOutline} color="danger" />
                        </IonButton>
                    </IonButtons>
                    )}
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <div className="unsupported-region-container">
                    {/* Background decorative elements */}
                    <div className="unsupported-region-bg-circle unsupported-region-bg-circle-1" />
                    <div className="unsupported-region-bg-circle unsupported-region-bg-circle-2" />

                    <div className="flex flex-col items-center justify-center h-full px-8 relative z-10">

                        {/* Animated icon */}
                        <motion.div
                            initial={{ scale: 0, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ type: 'spring', stiffness: 200, damping: 20, delay: 0.1 }}
                            className="unsupported-region-icon-container"
                        >
                            <div className="unsupported-region-icon-ring">
                                <IonIcon icon={globeOutline} className="unsupported-region-globe-icon" />
                            </div>
                            <div className="unsupported-region-shield-badge">
                                <IonIcon icon={shieldOutline} style={{ fontSize: '18px', color: '#fff' }} />
                            </div>
                        </motion.div>

                        {/* Title */}
                        <motion.h2
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.3, duration: 0.5 }}
                            className="unsupported-region-title"
                        >
                            {t('unsupported.region.HEADER')}
                        </motion.h2>

                        {/* Subtitle */}
                        <motion.p
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.45, duration: 0.5 }}
                            className="unsupported-region-subtitle"
                        >
                            {t('unsupported.region.SUBHEADER')}
                        </motion.p>

                        {/* Info card */}
                        <motion.div
                            initial={{ y: 30, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.6, duration: 0.5 }}
                            className="unsupported-region-info-card"
                        >
                            <IonIcon icon={shieldOutline} className="unsupported-region-info-icon" />
                            <p className="unsupported-region-info-text">
                                {t('unsupported.region.INFO')}
                            </p>
                        </motion.div>

                        {/* Logo watermark */}
                        <motion.img
                            src="/assets/img/ebioro-symbol-white.svg"
                            alt=""
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 0.06 }}
                            transition={{ delay: 0.8, duration: 1 }}
                            className="unsupported-region-watermark"
                        />

                    </div>
                </div>
            </IonContent>
        </>
    )

}

export default UnsupportedRegionModal